import React from 'react';
import { cva } from 'class-variance-authority';
import { emojiMap } from './constants/emojis';
import { EmojiProps } from '@/shared/types/emoji';
import { cn } from '@/shared/utils/cn';

export const Emoji: React.FC<EmojiProps> = ({ name, size, className }) => {
  const emoji = emojiMap[name as keyof typeof emojiMap];

  const variants = cva(`ui-inline-block ui-leading-none ${className}`, {
    variants: {
      size: {
        xxs: 'ui-text-body-xs-regular',
        xs: 'ui-text-body-xs-regular',
        sm: 'ui-text-sm',
        md: 'ui-text-base',
        lg: 'ui-text-lg',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  });

  return (
    <span className={cn('ui-imj', variants({ size }))} role="img" aria-label={name}>
      {emoji}
    </span>
  );
};
